<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<!-- <div class="back_left" @click="$router.back()"></div> -->
			<div class="big_tit">{{ $t('新闻资讯') }}</div>
		</div>
		<div class="tabs" style="margin-bottom:2px;">
          <van-tabs v-model="active" background="#F6F6F6" @click="tabs">
            <van-tab v-for="index in tabs" :title="index.title"></van-tab>
          </van-tabs>
        </div>
		<div class="item_wrap">
			<div class="items_3 items_4 item_margin">
				<div v-for="i in wealth_data" :key="i.id" class="items">
					<div class="item_img" @click="$router.push('/journalismDetail/' + i.id)">
						<img :src="i.img_url" alt="" />
					</div>
					<div class="t1">
						{{i.time}}
					</div>
					<div class="newsroom__title">
						{{ i.title }}
					</div>
				</div>
			</div>
			<div style="height:120px;background: #038566;"></div>	
		</div>
	</div>
</template>
<script>
import Fetch from '../../utils/fetch';
import Api from "../../interface/index"
import Vue from 'vue';
import { Tab, Tabs, Progress, Empty, Dialog, Field } from 'vant';
Vue.use(Tab).use(Tabs).use(Progress).use(Empty).use(Dialog).use(Field);
export default {
	name: "item",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			tabs: [],
			active: 0,
			wealth_data: [],
			listLength: 0,
			show_ts: false,
			wealth_number: "",
			wealth_sku: [],
			isSig:1
		}
	},
	created() {
		this.$parent.footer('journalism');
		Fetch("/news/getCateList").then((r) => {
			this.tabs = r.data
			this.cateStart( this.tabs[0].id);
		});
		Fetch("/user/info").then((r) => {
        if(r.data.is_sign) {
            this.isSig = 2
            return
        }
        this.isSig = 1
    });
	},
	mounted() {
		// var type = 0;
		// if (this.$router.history.current.query.type) {
		// 	this.active = parseInt(this.$router.history.current.query.type);
		// 	type = this.$router.history.current.query.type;
		// }
		// this.wealthStart(type);
	},
	methods: {
		cancelFun() {
			this.wealth_number = ''
		},
		cateStart(type) {
			Fetch('/news/getCateNewsList', {
				cate_id: type
			}).then(r => {
				this.wealth_data = r.data;
			})
		},
		sort(type) {
			this.cateStart(this.tabs[type].id);
		},
		wealthBuy(item) {
			if(this.isSig === 1){
				this.$router.push('/contract')
				return
			}
			this.wealth_sku = item;
			this.show_ts = true;
		},
		wealthConfirm() {
			// if (!this.wealth_number) {
			// 	this.$toast(this.$t('item.inputAmount'));
			// 	return false;
			// }
			Fetch("/index/item_apply", {
				id: this.wealth_sku.id,
				money: this.wealth_sku.fixed_investment_amount
			}).then(r => {
				this.$toast(r.msg)
				if (r.code == 1) {
					this.$toast(r.info)
					setTimeout(() => {
						this.$router.push("/order");
					}, 500);
					return 
				}
			}).catch(err => {
				// this.psd_val = '';
			})
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-cell {
	padding: 15px 26px;
}

.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
}

.basic_wrap {
	position: relative;
	.tabs {
		position: fixed;
		top:44px;
		z-index: 100;
		width: 100%;
		max-width: 750px;
	}
}

.item_wrap {
	width: 100%;
}

.item_margin {
	padding-top: 90px !important;
}
.h-title {
  font-size: 18px;
  padding: 18px 10px 6px 10px;
  font-weight: bold;
  font-size: 24px;
  font-weight: bold;
  color: transparent;
  background: linear-gradient(90deg, #0E726D, #FACB8F);
  -webkit-background-clip: text;
  background-clip: text;
  position: relative;
  display: inline-block;
}
.items {
  background: #038566;
  padding: 5%;
  .item_img {
    width: 100%;
    height: 198px;
    margin-bottom: 20px;
    img {
      width: 100%;
      display: block;
      height: 100%;
    }
  }
  .t1 {
    color: #29f5d5;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .newsroom__title {
    font-family: "Beatrice Bold",Arial,Helvetica,sans-serif;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: normal;         /* 依据语言规则在单词间换行 */
    white-space: normal;        /* 合并多余空格，在换行符和容器边缘处换行 */
    font-size: 22px;
    color: #fff;
    display: block;
    font-weight: bold;
    line-height: 30px;
    padding-bottom: 20px;
  }
}
</style>
